import * as Configuration from '../../app.constants.js';

export class ExternalUserService {
  constructor($http, $q, AsyncRequestFactory) {
    this.$http = $http;
    this.$q = $q;
    this.AsyncRequestFactory = AsyncRequestFactory;
  }

  userAction(companyId, userId, data, include_refreshed_allowed_actions) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId 
              + '/external-users/' + userId + '/actions' 
              + '?include_refreshed_allowed_actions=' + include_refreshed_allowed_actions
    return this.$http.post(url, data);
  }

  listUserActions(companyId, userId, params) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/external-users/' + userId, {
      params: params
    }).then(result => result.data, error => error);
  }

  getUserInteractions(companyId, siteId, userId, format_only_n_messages) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId 
              + '/sites/' + siteId + '/users/' + userId 
              + '/interactions?format_only_n_messages=' + format_only_n_messages
    return this.AsyncRequestFactory.get(companyId, url);
  }

  lazyloadMessages(companyId, siteId, userId, messageIds) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId 
              + '/sites/' + siteId + '/users/' + userId 
              + '/interactions/lazyload-messages';
    return this.$http.post(url, messageIds);
  }

  getLinkedUsersAndCrmOrgs(companyId, siteId, userId) {
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId 
                          + '/linked-users/' + userId + '?include_crm_orgs=true');
  }

  setGroupName(companyId, siteId, userId, groupName) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + siteId 
              + '/linked-users/' + userId + '/group-name';
    const data = {
      'group_name': groupName
    };
    return this.$http.put(url, data);
  }

  getCanSendPrivateMessageAsOtherSite(companyId, userId, refreshSiteId) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/external-user/' + userId + '/can-send-private-message-as-other-site/' + refreshSiteId;
    return this.AsyncRequestFactory.get(companyId, url);
  }

  static ExternalUserFactory($http, $q, AsyncRequestFactory) {
    return new ExternalUserService($http, $q, AsyncRequestFactory);
  }
}
ExternalUserService.ExternalUserFactory.$inject = ['$http', '$q', 'AsyncRequestFactory'];
